import React from 'react'
import './Dash.css'
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'
import TripComp from './TripComp'

function Trips() {
    return (
        <div className='contentMain'>
            <LeftBar />
            <div className='theRightOne'>
                <div className='DashTop'>
                    <h1>Trips</h1>
                    <NavBar />
                </div>
                < TripComp />
            </div>
        </div>
    )
}

export default Trips